export const FIELD_TYPES = {
	TEXT: 'text',
	PASSWORD: 'password',
	CHECKBOX: 'checkbox',
	EMAIL: 'email',
	SELECT: 'select',
	CASCADER: 'cascader',
	CUSTOM: 'custom'
	
};